export default __webpack_public_path__ + "static/7626-bbe20217ceb7cdc961c4c27b65d924b5.jpg";